// extracted by mini-css-extract-plugin
export default {"forumPosts":"qKe9oFkGxMPrs02dOkag"};